import sanitizeHtml from 'sanitize-html'

// Canonical Situation-A renderer for tenant-authored HTML in admin DOM.
// See docs/architecture/frontend-security-model.md.

const RICH_TEXT_OPTIONS = {
  allowedTags: [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'p', 'br', 'hr', 'div', 'span',
    'b', 'i', 'u', 's', 'strong', 'em', 'sub', 'sup',
    'ul', 'ol', 'li',
    'blockquote', 'pre', 'code',
    'a',
    'figure', 'figcaption', 'img',
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
  ],
  allowedAttributes: {
    'a': ['href', 'target', 'rel', 'title'],
    'img': ['src', 'alt', 'title', 'width', 'height'],
    'td': ['colspan', 'rowspan'],
    'th': ['colspan', 'rowspan'],
    '*': ['class', 'style'],
  },
  allowedSchemes: ['http', 'https', 'mailto'],
  allowedSchemesAppliedToAttributes: ['href', 'src'],
  allowProtocolRelative: false,
  disallowedTagsMode: 'discard',
}

const EMAIL_BLOCK_OPTIONS = {
  allowedTags: [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'p', 'br', 'hr', 'div', 'span', 'center',
    'b', 'i', 'u', 's', 'strong', 'em', 'sub', 'sup', 'small',
    'ul', 'ol', 'li',
    'blockquote', 'pre', 'code',
    'a',
    'figure', 'figcaption', 'img',
    'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'caption', 'col', 'colgroup',
    'wrapper',
  ],
  allowedAttributes: {
    'a': ['href', 'target', 'rel', 'title', 'name'],
    'img': ['src', 'alt', 'title', 'width', 'height', 'align', 'border'],
    'table': ['width', 'align', 'border', 'cellpadding', 'cellspacing', 'role'],
    'td': ['colspan', 'rowspan', 'align', 'valign', 'width', 'height'],
    'th': ['colspan', 'rowspan', 'align', 'valign', 'width', 'height'],
    'tr': ['align', 'valign'],
    '*': ['class', 'style'],
  },
  allowedSchemes: ['http', 'https', 'mailto'],
  allowedSchemesAppliedToAttributes: ['href', 'src'],
  allowProtocolRelative: false,
  disallowedTagsMode: 'discard',
}

const PRESETS = {
  'rich-text': RICH_TEXT_OPTIONS,
  'email-block': EMAIL_BLOCK_OPTIONS,
}

export function sanitize(html, preset = 'rich-text') {
  if (html == null || html === '') return ''
  const options = PRESETS[preset]
  if (!options) {
    throw new Error(`SanitizedHtml: unknown preset "${preset}"`)
  }
  return sanitizeHtml(String(html), options)
}

export default function SanitizedHtml({
  html,
  preset = 'rich-text',
  tag: Tag = 'div',
  className,
  ...rest
}) {
  const clean = sanitize(html, preset)
  return (
    <Tag
      {...rest}
      className={className}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  )
}
